// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HeSl0","left":"styles_left__1lXi_","desktopActions":"styles_desktopActions__18n2m","title":"styles_title__3aYwl"};